module.exports = __webpack_public_path__ + "static/media/applet_job.ee7f973e.png";